export const CHECK_USER_FIRM_JOB_ASSIGNMENT_QUERY = `
  query CheckUserFirmJobAssignment($userId: Int!, $firmId: Int!) {
    job_assignments(
      where: {
        _or: [
          { technical_user_id: { _eq: $userId } },
          { financial_user_id: { _eq: $userId } }
        ],
        job: {
          firm_id: { _eq: $firmId },
          job_status: { _nin: ["TAMAMLANDI", "DANISMANLIK_SONLANDIRILDI", "KAPATILDI", "REDDEDILDI"] }
        }
      },
      limit: 1
    ) {
      id
    }
  }
`;

export const GET_FIRM_IDS_BY_TEAM_QUERY = `
  query GetFirmIdsByTeam($teamId: Int!) {
    user_firms(where: { user: { team_id: { _eq: $teamId } } }) {
      firm_id
    }
  }
`;

export const GET_FIRM_IDS_BY_USER_QUERY = `
  query GetFirmIdsByUser($userId: Int!) {
    user_firms(where: { user_id: { _eq: $userId } }) {
      firm_id
    }
  }
`;

export const GET_USER_FIRMS_BY_USER_QUERY = `
  query GetUserFirmsByUser($userId: Int!) {
    user_firms(where: { user_id: { _eq: $userId } }, order_by: { created_at: desc }) {
      id
      user_id
      firm_id
      company_id
      created_at
      firm {
        id
        firm_name
        firm_short_name
        firm_city
      }
    }
  }
`;
